// Centralized Global Configuration State Controller
// Supported values: "ALPHA" | "CORPORATE_ACTIVE" | "PRODUCTION"
export const APPLICATION_STAGE: "ALPHA" | "CORPORATE_ACTIVE" | "PRODUCTION" = "PRODUCTION";

export interface StageConfig {
  footerText: string;
  emailSignatureName: string;
  emailSignatureTitle: string;
  emailSignatureOrg: string;
  supportEmail: string;
  hasAcademicLayer: boolean;
  hasLicensingBlock: boolean;
  preprintDoi?: string;
  preprintDoiUrl?: string;
  softwareDoi?: string;
  softwareDoiUrl?: string;
  orcidId?: string;
  arxivLink?: string;
  licenseNotice?: string;
}

export const STAGE_CONFIG: Record<"ALPHA" | "CORPORATE_ACTIVE" | "PRODUCTION", StageConfig> = {
  ALPHA: {
    footerText: "© 2026 Aghora Abraham Global LLC (BhutaDamaraSena R&D Labs). All Rights Reserved.",
    emailSignatureName: "BhutaDamaraSena R&D Labs",
    emailSignatureTitle: "Acoustic Engineering & Epigraphy Division",
    emailSignatureOrg: "Aghora Abraham Global LLC",
    supportEmail: "support@bhutadamarasena.com",
    hasAcademicLayer: false,
    hasLicensingBlock: false,
    orcidId: "",
    arxivLink: "",
    licenseNotice: "",
  },
  CORPORATE_ACTIVE: {
    footerText: "© 2026 Aghora Abraham Global LLC (BhutaDamaraSena R&D Labs). All Rights Reserved.",
    emailSignatureName: "BhutaDamaraSena R&D Labs",
    emailSignatureTitle: "Lead Principal Research Architect",
    emailSignatureOrg: "Aghora Abraham Global LLC",
    supportEmail: "support@bhutadamarasena.com",
    hasAcademicLayer: true,
    hasLicensingBlock: true,
    orcidId: "0009-0004-9876-5432",
    arxivLink: "https://doi.org/10.5281/zenodo.23361838",
    licenseNotice: "Copyright (c) 2026 Aghora Abraham Global LLC. BhutaDamaraSena R&D Labs.",
  },
  PRODUCTION: {
    footerText: "© 2026 Aghora Abraham Global LLC (BhutaDamaraSena R&D Labs). All Rights Reserved.",
    emailSignatureName: "BhutaDamaraSena R&D Labs",
    emailSignatureTitle: "Lead Principal Research Architect & Acoustic Engineering Division",
    emailSignatureOrg: "Aghora Abraham Global LLC (Self-MoR)",
    supportEmail: "support@bhutadamarasena.com",
    hasAcademicLayer: true,
    hasLicensingBlock: true,
    preprintDoi: "10.5281/zenodo.23361838",
    preprintDoiUrl: "https://doi.org/10.5281/zenodo.23361838",
    softwareDoi: "10.5281/zenodo.23391403",
    softwareDoiUrl: "https://doi.org/10.5281/zenodo.23391403",
    orcidId: "0009-0004-9876-5432",
    arxivLink: "https://doi.org/10.5281/zenodo.23361838",
    licenseNotice: "Certified Production Release. Zenodo Preprint DOI: 10.5281/zenodo.23361838 • Software DOI: 10.5281/zenodo.23391403. Aghora Abraham Global LLC & BhutaDamaraSena R&D Labs.",
  }
};

export const CURRENT_CONFIG: StageConfig = STAGE_CONFIG[APPLICATION_STAGE];
